import React, { MouseEvent, FunctionComponent } from 'react';
import classnames from 'classnames';

// styles
import styles from './main.scss';
type ButtonType = 'button';
type ResetType = 'reset';
type SubmitType = 'submit';

export type ButtonTypesType = ButtonType | ResetType | SubmitType | undefined;

type StyledButtonProps = {
    className?: string;
    children?: React.ReactNode;
    dataTn: string;
    disabled?: boolean;
    href?: string;
    isPrimary?: boolean;
    onClick?: (e: MouseEvent<HTMLElement>) => void;
    rel?: string;
    tabIndex?: number;
    target?: string;
    type?: ButtonTypesType;
    value?: string;
    ariaLabel?: string;
};

export const StyledButton: FunctionComponent<StyledButtonProps> = props => {
    const {
        className,
        children,
        dataTn,
        disabled,
        href,
        isPrimary = false,
        onClick,
        rel,
        tabIndex,
        target,
        type,
        value,
        ariaLabel,
    } = props;

    const styledButtonClasses = classnames(
        styles.button,
        {
            [styles.primaryButton]: isPrimary,
            [styles.disabled]: disabled,
        },
        className
    );

    const extraProps = {
        disabled,
        onClick,
        rel,
        tabIndex,
        target,
        value,
    };

    if (typeof href === 'string') {
        return (
            <a
                aria-label={ariaLabel}
                className={styledButtonClasses}
                data-tn={dataTn}
                href={disabled ? undefined : href}
                {...extraProps}
            >
                {children}
            </a>
        );
    } else {
        return (
            <button
                aria-label={ariaLabel}
                className={styledButtonClasses}
                data-tn={dataTn}
                type={type}
                {...extraProps}
            >
                {children}
            </button>
        );
    }
};
